import React, {Component} from 'react';
import {connect} from 'react-redux';
import cssClasses from './Disc.css'
import {MdRefresh, MdFileUpload} from 'react-icons/md';
import * as actionCreators from '../../../../../store/actions/index'
import {keyframes} from "styled-components";

class Disc extends Component {

    componentDidMount() {
        this.props.audio.audioRef.current.addEventListener('loadedmetadata', (e) => {
            this.props.onMetaDataLoaded(e, this.props.id)
        });
    }

    render() {
        const spin = keyframes`
            100% { transform:rotate(360deg); }
        `;
        const rotateDiscStyle = (this.props.audio && this.props.audio.playingStatus === 'PLAYING') ? {
            animation: `${spin} 4s linear infinite`,
            background: `center / contain no-repeat url(${this.props.audio.logo})`
        } : {background: `center / contain no-repeat url(${this.props.audio.logo})`}
        let innerDiscButton = (
            <React.Fragment>
                <label className={cssClasses.UploadSong} htmlFor={"file_upload" + this.props.id}>
                    <MdRefresh/>
                    <p>New Audio</p>
                </label>
            </React.Fragment>
        );
        if (this.props.audio.file != null) {
            innerDiscButton = (
                <React.Fragment>
                    <label className={cssClasses.UploadSong} htmlFor={"file_upload" + this.props.id}>
                        <MdFileUpload/>
                        <p>New Audio</p>
                    </label>
                </React.Fragment>
            )
        }
        return (
            <div className={cssClasses.Disc}
                 style={rotateDiscStyle}>
                <div className={cssClasses.DiscHole}>
                    <div className={cssClasses.DiscInfo}>
                        <div className={cssClasses.DiscNumber}>
                            {innerDiscButton}
                            <input type="file" id={"file_upload" + this.props.id} className="d-none" accept=".mp3,.wav"
                                   onChange={(e) => this.props.onAudioChange(e, this.props.audio)}/>
                            <audio
                                src={this.props.audio.file}
                                ref={this.props.audio.audioRef}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        audio: state.audios[ownProps.id]
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAudioChange: (event, audio) => dispatch(actionCreators.audioChangeHandler(event, audio)),
        onMetaDataLoaded: (event, audioIndex) => dispatch(actionCreators.metaDataLoadedHandler(event, audioIndex))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Disc);